export default "__VITE_ASSET__g11vc4s1__"